<template>
  <section>
    <confirm-personal-topic/>
  </section>
</template>

<script>
  import ConfirmPersonalTopic from '../privacy/ConfirmPersonalTopic'

  export default {
    components: {
      ConfirmPersonalTopic
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/PersonalDataManagement.vue